import { useSelector } from "react-redux"

import Card from "../../../../common/Card"
import RelatedPatientsSearchResultsButton from "./RelatedPatientsSearchResultsButton"

import classes from './RelatedPatientsSearchResults.module.css'

const RelatedPatientsSearchResults = ({closeModal}) => {   
    const searchResults = useSelector(state => state.search.relatedPatientsResults)   

    return <>
        {searchResults && searchResults.length > 0 && <div className={classes.search_results}>
            <Card>
                <div className={classes.search_results_inner}>
                    {searchResults.map(patient => (
                        <RelatedPatientsSearchResultsButton key={patient.id} patientData={patient} closeModal={closeModal}/>
                    ))}
                </div>
            </Card>
        </div> }
    </>
}

export default RelatedPatientsSearchResults